export default el => {
	if (matchMedia('(min-width: 700px').matches && undefined !== el.dataset.autoplay) {
		el.muted = true;
		el.play();
	}
};
